import * as types from './Types.js';

export function findContratosPorLicitacao(
  entidade,
  exercicio,
  tipoLicitacao,
  licitacao
) {
  return ({ fetch }) => ({
    type: types.CONTRATOS_LICITACAO,
    payload: {
      promise: fetch(
        `/api/contratos/licitacao?entidade=${entidade}&exercicioLicitacao=${exercicio}&tipoLicitacao=${tipoLicitacao}&numeroLicitacao=${licitacao}`
      )
    }
  });
}

export function findAditivos(entidade, exercicio, contrato) {
  return ({ fetch }) => ({
    type: types.ADITIVOS,
    payload: {
      promise: fetch(
        `/api/aditivos?entidade=${entidade}&exercicio=${exercicio}&contrato=${contrato}`
      )
    }
  });
}

export function findResponsaveis(entidade, exercicio, contrato) {
  return ({ fetch }) => ({
    type: types.RESPONSAVEIS,
    payload: {
      promise: fetch(
        `/api/responsaveis?entidade=${entidade}&exercicio=${exercicio}&contrato=${contrato}`
      )
    }
  });
}

export function findContrato(entidade, exercicio, contrato) {
  return ({ fetch }) => ({
    type: types.CONTRATO,
    payload: {
      promise: fetch(
        `/api/contratos?entidade=${entidade}&exercicio=${exercicio}&contrato=${contrato}`
      )
    }
  });
}

export function findContratoObra(entidade, exercicio, contrato) {
  return ({ fetch }) => ({
    type: types.CONTRATO,
    payload: {
      promise: fetch(
        `/api/contratos/obra?entidade=${entidade}&exercicio=${exercicio}&contrato=${contrato}`
      )
    }
  });
}

export function searchContratos(filter) {
  let url = '/api/contratos?' + filter;

  return ({ fetch }) => ({
    type: types.CONSULTA_CONTRATOS,
    payload: {
      promise: fetch(url)
    }
  });
}

export function loadTiposContrato() {
  return ({ fetch }) => ({
    type: types.TIPOS_CONTRATO,
    payload: {
      promise: fetch('/api/tipos-contratos')
    }
  });
}

export function resetConsulta() {
  return {
    type: types.RESET_CONSULTA_CONTRATOS
  };
}

export function findArquivos(entidade, exercicio, contrato) {
  return ({ fetch }) => ({
    type: types.CONTRATO_ARQUIVOS,
    payload: {
      promise: fetch(
        `/api/contratos/arquivos?entidade=${entidade}&exercicio=${exercicio}&contrato=${contrato}`
      )
    }
  });
}
